import { Component, input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'tfs-divider',
  imports: [MatDividerModule],
  template: `<mat-divider [vertical]="vertical()" [inset]="inset()"></mat-divider>`,
})
export class DividerComponent {
  vertical = input(false);
  inset = input(false);

  //tmp change for testing
}
